module.exports = __webpack_public_path__ + "img/barre-5.024fd431.png";